export default __webpack_public_path__ + "MIR.b494588a.svg";